import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-sale',
  template: ``,
  styleUrls: []
})
export class EditSaleComponent {

}
